import { ObservableArray, View } from "binder"
import { productGroup, ProductGroupDefinitionViewModel } from "./productGroupDefinition-viewModel"

export class ProductGroupDefinitionView extends View<ProductGroupDefinitionViewModel>{
    GetViewUniqueId(): string {
        return "V-B260561E-0261-4289-9013-E3DAD0B2CD28"
    }
    loadHtml(): string {
        let element = require('./productGroupDefinition.html').default;
        let style = require('./productGroupDefinition.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set groups(v: ObservableArray<productGroup>) { this._groups = v; } public get groups(): ObservableArray<productGroup> { return this._groups;} private _groups: ObservableArray<productGroup>;
    
    addChild(){
        this.dataContext.addChild();
    }

    save(){
        this.dataContext.save();
    }
}
